import { GetStaticProps, NextPage } from 'next'
import React, { useEffect, useState } from 'react'
import { Footer } from 'src/components/Footer/Footer'
import HomeBuyVendorBadge from 'src/components/global/HomeBuyVendorBadge/HomeBuyVendorBadge'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { IPrivacyPolicyEntity } from 'src/graphql/generated/hooks'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'

type Props = {
  privacyPolicy: IPrivacyPolicyEntity
}

const CookiePolicyPage: NextPage<Props> = ({ privacyPolicy }: Props) => {
  const [minHeight, setMinHeight] = useState(0)
  const date = privacyPolicy && privacyPolicy.attributes?.date ? new Date(privacyPolicy.attributes?.date) : null
  const dateStr = date
    ? 'UPDATED ON ' +
      date.toLocaleString('default', { month: 'long' }) +
      ' ' +
      date.getDay().toString() +
      ', ' +
      date.getFullYear().toString()
    : ''
  useEffect(() => {
    // window is accessible here.
    const innerHegiht = window.innerHeight
    const minHeight = innerHegiht - 590
    setMinHeight(minHeight)
  }, [])

  const meta = <Meta title="Cookie Policy" description="Cookie Policy" url="/cookie-policy/" />

  return (
    <Main meta={meta}>
      <div id="mainContainer" className="policy-container">
        <div className="flex flex-col bg-clouds">
          {privacyPolicy && (
            <div className="flex flex-row justify-center bg-clouds">
              <div className="pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full flex flex-col py-2">
                <span className="text-darkgray font-primary font-regular text-[13px] tracking-normal cursor-pointer py-6">
                  {dateStr.toUpperCase()}
                </span>
                <HomeBuyVendorBadge />
                <div className="sm:grid-cols-2">
                  <div className="self-center">
                    <h1 className="pt-[0.5rem] pb-[0.625rem] text-[30px] font-bold font-secondary text-darkgray">
                      Privacy Policy
                    </h1>
                    <h3 className="terms-content text-[1.125rem] font-primary font-regular text-darkgray mb-8">
                      <HtmlContentViewer html={privacyPolicy.attributes?.summary || ''} />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <hr />
        <div className="flex flex-row justify-center w-full" style={{ minHeight: minHeight }}>
          <div className="!max-w-[1100px] w-full mb-32 font-primary font-regular text-darkgray text-[16px] md:pr-[14.5rem] pl-[1.25rem] pr-[1.25rem]">
            {privacyPolicy && <HtmlContentViewer html={privacyPolicy.attributes?.content || ''} />}
          </div>
        </div>
        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </div>
    </Main>
  )
}

export default CookiePolicyPage

export const getStaticProps: GetStaticProps = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }
  try {
    const { privacyPolicy } = await apolloSdk.getPrivacyPolicy()
    const data = privacyPolicy?.data
    return {
      props: {
        privacyPolicy: data,
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of cookie policy:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 60, // Reattempt fetching during the next static regeneration
    }
  }
}
